import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { View } from 'react-native';
import { PANEL_VIEW_MODE_WIDTH, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import ToolsGeneralContent from '@v2/pages/machines/modules/now/components/Tools/components/ToolsGeneralContent';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { scale } from '@components/frame';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { isWeb } from '@helpers';

interface JobDetailsToolsProps {}

const JobDetailsToolsComponent: FC<JobDetailsToolsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  // TODO: When adding tools functionality for this page, pass refetchTools prop to ToolsGeneralContent
  return (
    <DetailsPageWrapper title={title.tool}>
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
        <ToolsGeneralContent maxDetailsWidth={PANEL_VIEW_MODE_WIDTH} bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'} />
      </View>
    </DetailsPageWrapper>
  );
};

const JobDetailsTools = connect(({}) => ({}), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsToolsComponent);

export { JobDetailsTools };
